import React from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { useTranslation } from "react-i18next"
import { formatPlanCap, getPlanIncludedFeatures } from "./planDetailsUtils"
import { getCurrencyLabel } from "utils/currency"

const PlanDetailsModal = ({ plan, isOpen, onClose }) => {
  const { t } = useTranslation()

  if (!plan) {
    return null
  }

  const features = getPlanIncludedFeatures(plan, t)
  const billingLabel =
    plan.billingCycle === "annual" || plan.billingCycle === "yearly"
      ? t("year")
      : t("month")

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      size="md"
      className="onboarding-plan-details-modal"
    >
      <ModalHeader toggle={onClose}>
        <span className="onboarding-plan-details-modal__title">{plan.name}</span>
      </ModalHeader>
      <ModalBody>
        {plan.description ? (
          <p className="onboarding-plan-details-modal__desc text-muted mb-3">
            {plan.description}
          </p>
        ) : null}

        <div className="onboarding-plan-details-price mb-4">
          {getCurrencyLabel(plan.currency || "SAR")}{" "}
          {Number(plan.price || 0).toFixed(2)}
          <span className="text-muted fs-6 fw-normal">
            {" / "}
            {billingLabel}
          </span>
        </div>

        <div className="onboarding-plan-details-limits mb-4">
          <h6 className="fw-semibold mb-2">{t("Plan limits")}</h6>
          <ul className="list-unstyled mb-0 onboarding-plan-details-limit-list">
            <li>
              <i className="bx bx-user me-2 text-primary" />
              <span className="text-muted">{t("Admin users")}:</span>{" "}
              <strong>{formatPlanCap(plan.maxAdminUsers, t)}</strong>
            </li>
            <li>
              <i className="bx bx-map me-2 text-primary" />
              <span className="text-muted">{t("Branches")}:</span>{" "}
              <strong>{formatPlanCap(plan.maxBranches, t)}</strong>
            </li>
          </ul>
        </div>

        {features.length > 0 ? (
          <div>
            <h6 className="fw-semibold mb-2">{t("Included features")}</h6>
            <ul className="onboarding-plan-details-features mb-0">
              {features.map((item, idx) => (
                <li key={`${item.label}-${idx}`}>
                  <i className="bx bx-check text-success me-2" />
                  <span>{item.label}</span>
                  {item.hint ? (
                    <span className="d-block small text-muted ms-4 ps-1">
                      {item.hint}
                    </span>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <p className="text-muted small mb-0">
            {t("No feature list available for this plan.")}
          </p>
        )}
      </ModalBody>
    </Modal>
  )
}

export default PlanDetailsModal
